// FeatureSection.js

import React from 'react';
import './Features.css';
import feature1 from '../assets/f1.mp4';
import feature2 from '../assets/f2.mp4'; // Replace with your image path
import feature3 from '../assets/f3.mp4'; 
import feature4 from '../assets/f4.mp4';// Replace with your image path


const Features = () => {


  return (
    <section className="features-section" id="features">
      <h2 className="section-title">Protect Your Privacy and Take Control with Our Key Features </h2>
      {/* <h3 className="section-subtitle"></h3> */}
      <div className="cards-container">

        {/* First Card */}
        <div className="features-card">
          <div className="features-content">
            <h3>Seamless Setup, Instant Protection</h3>
            <ul>
              <li>Adding our extension to your browser is as easy as a click, and once it's in, you’re protected. No interruptions, just peace of mind.</li>
              <li>You won’t even notice it working in the background, but rest assured, it’s scanning for any potential risks while you browse.</li>
            </ul>
    
          </div>
          <div className="features-videos">
         <video className="feature-video-1" autoPlay muted loop>
        <source src={feature1 } type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
        </div>

        {/* Second Card */}
        <div className="features-card reverse">
        <div className="features-videos">
         <video className="feature-video-2" autoPlay muted loop>
        <source src={feature2 } type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
          <div className="features-content">
            <h3>Real-Time Data Monitoring & Alerts</h3>
            <ul>
              <li>Our extension scans sensitive data, alerting you immediately before any data is uploaded.</li>
              <li>You decide whether to proceed or stop—your security, your decision.</li>
            </ul>
            {/* <button className="cta-button">Learn More</button> */}
          </div>
        </div>

        {/* Third Card */}
        <div className="features-card">
          <div className="features-content">
            <h3>Customizable Privacy Settings</h3>
            <ul>
              <li>Personalize alerts to track specific types of data, like financial, medical and personal information.</li>
              <li>Adjust the sensitivity level based on your privacy needs, and stay in full control of your online security.</li>
            </ul>
            {/* <button className="cta-button">Get Started</button> */}
          </div>
          <div className="features-videos">
         <video className="feature-video-3" autoPlay muted loop>
        <source src={feature3 } type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
        </div>

        {/* Fourth Card */}
        <div className="features-card reverse">
        <div className="features-videos">
         <video className="feature-video-4" autoPlay muted loop>
        <source src={feature4 } type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
          <div className="features-content">
            <h3>Insightful Dashboard for Long-Term Protection</h3>
            <ul>
              <li>Track past alerts and assess risk trends to understand your privacy health.</li>
              <li>Make informed decisions with a clear view of your data security, giving you long-term peace of mind.</li>
            </ul>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Features;

